'use client';
/** Открывает окно и отправляет событие аналитики */ function clickToCall(options) {
    if (!(typeof window === "object" && "open" in window)) {
        return;
    }
    var _ref = options || {}, _ref_web = _ref.web, web = _ref_web === void 0 ? true : _ref_web, _ref_webUrl = _ref.webUrl, webUrl = _ref_webUrl === void 0 ? "https://www.s7.ru/click-to-call/" : _ref_webUrl, _ref_appUrl = _ref.appUrl, appUrl = _ref_appUrl === void 0 ? "https://link.api.s7.ru/clicktocall" : _ref_appUrl, _ref_windowFeatures = _ref.windowFeatures, windowFeatures = _ref_windowFeatures === void 0 ? "width=350,height=500,resizable=no,toolbar=no,menubar=no,location=no,status=no" : _ref_windowFeatures;
    web ? window.open(webUrl, "_blank", windowFeatures) : window.open(appUrl, "_blank");
}

export { clickToCall };
